module.exports = __webpack_public_path__ + "img/cash-recap.528fdc20.png";